export default {"src":"/_next/static/media/getting-started-boat.colour.1e67edcc.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};